import React from 'react';
import { extend } from '@thd-nucleus/data-sources';
import { AisleBay } from '../components/AisleBay';
import { useSearchContext } from '../hooks/useSearchContext';
import { useConfigService } from '@thd-nucleus/experience-context';


const AisleBayComposable = () => {
    const { products, keyword, resolved, hasInStoreFilter, data, isPLPSearchPage } = useSearchContext();

    const areMajorityOfProductsMajorAppliances = (products) => {
        if (!products?.length) {
            return false;
        }
        const majorApplianceCount = products.filter(
            (product) => product?.identifiers?.productType === 'MAJOR_APPLIANCE'
        )?.length;
        return majorApplianceCount / products.length >= 0.5;
    };

    const isPlpSpeedEnabled = useConfigService('fs-prop:isPlpSpeedEnabled')
        && !areMajorityOfProductsMajorAppliances(data?.searchModel?.products);

    if (isPLPSearchPage && !isPlpSpeedEnabled && resolved && hasInStoreFilter(data)) {
        return (
            <div data-testid="aisle-bay-component">
                <AisleBay
                    products={products}
                    searchKeyword={keyword}
                />
            </div>
        );
    }

    return null;
};

AisleBayComposable.displayName = 'AisleBayComposable';

AisleBayComposable.dataModel = extend({}, useSearchContext, AisleBay);

export { AisleBayComposable };